module.exports = __webpack_public_path__ + "img/measuring_meters_dark.063e5713.svg";